import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckoutLicensesComponent} from './checkout-licenses.component';
import {I18nModule} from '@spartacus/core';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';

@NgModule({
  imports: [CommonModule, I18nModule, CartEditModule, CheckoutLicensesComponent],
  exports: [CheckoutLicensesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CheckoutLicensesModule {}
